import React, { useCallback, useState, useEffect, useRef, memo } from 'react';
import { Progress } from 'antd';
import Button from '../../../../components/button/Button';
import MarkCheckIcon from '@src/assets/icons/mark_check.svg?react';
import styles from './Actions.module.scss';
import { useCourseContent } from '@src/hooks';

export const ProgressAfterConfetti = memo(({ goBack }: { goBack?: () => void }) => {
  const [percent, setPercent] = useState<number>(0);
  let countDownTimer = useRef<NodeJS.Timeout | null>(null);
  const { section, startedAlternateLesson, isViewExitTicket, setShowCompleteUnit } = useCourseContent();

  const startCountDown = useCallback(() => {
    countDownTimer.current = setInterval(() => {
      setPercent(p => {
        if (p >= 99) {
          if (goBack) {
            goBack();
          }
          if (countDownTimer.current) {
            clearInterval(countDownTimer.current);
          }
          return p;
        }
        return p + 1
      });
    }, 6000 / 100)
  }, [goBack]);

  useEffect(() => {
    startCountDown();
    return () => {
      if (countDownTimer.current) {
        clearInterval(countDownTimer.current)
        countDownTimer.current = null;
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onReturn = useCallback(() => {
    if (goBack) {
      goBack();
    }
    if (isViewExitTicket) {
      setShowCompleteUnit(true);
    }
  }, [goBack, setShowCompleteUnit, isViewExitTicket]);

  return (
    <div className={styles.progressContainer}>
      <div className={styles.notifyExplain}>
        {isViewExitTicket || startedAlternateLesson ?
        <div className={styles.congratsView}>
          <div className={styles.notifyTitle}><MarkCheckIcon width={48} height={48}/><h2>{`Congratulations! ${startedAlternateLesson ? section?.name : 'Lesson'} Completed.`}</h2></div>
        </div> :
        <span>{'This lesson needs to be approved before you can move onto the next Lesson.'}</span>
        }
      </div>
      <div className={styles.notifyDetailView}>
        <div className={styles.notifyDetailTitle}>
          <p>Returning to Unit Overview In:</p>
        </div>
        <Progress
          type="circle" percent={percent} width={207} strokeWidth={5} strokeColor="#62C590" trailColor="#D9D9D91A"
          format={(p) => <div className={styles.leftSecText}>{Math.ceil(6 - 6.0 / 100 * (p || 0))}</div>}
        />
      </div>
      <div className={styles.returnButtonContainer}>
        <Button size={'small'} onClick={onReturn} outline={true} className={styles.returnButton} label={'Return Now'}/>
      </div>
    </div>
  )
});
